import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

@ngCore.Component({
  imports: [ds.tag.Component, ngCommon.NgIf],
  providers: [ngCommon.TitleCasePipe],
  selector: 'atn-model-card',
  standalone: true,
  styleUrls: ['./model-card.component.scss'],
  templateUrl: './model-card.component.html',
})
export class AtnModelCardComponent {
  private readonly _titleCasePipe = ngCore.inject(ngCommon.TitleCasePipe)

  public modelSg = ngCore.input.required<ents.core.dms.models.Model>({
    alias: 'model',
  })

  public modelNameSg = ngCore.computed((model = this.modelSg()) => model.name)

  public modelDescriptionSg = ngCore.computed(
    (model = this.modelSg()) => model.description,
  )

  public modelTypeSg = ngCore.computed((model = this.modelSg()) =>
    model.id
      ? this._titleCasePipe.transform(ents.core.dms.models.Type.from(model.id))
      : undefined,
  )

  public widthSg = ngCore.input<string, string | number>('auto', {
    transform: value =>
      !Number.isNaN(value) ? `${value}px` : value.toString(),
  })
}
